import {
  Button,
  FormControl,
  Input,
  NumberInput,
  NumberInputField,
  Select,
  Td,
  Tr
} from "@chakra-ui/react";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import { LancamentoFinanceiro } from "models/lancamento_type";
import { PessoaType } from "models/person_type";
import { UsuarioModel } from "models/user_model";
import { useState } from "react";
import formatNumber from "views/admin/order/hooks/formatNumber";

interface IAddLancamentoRow {
  showError: (title: string, msg: string) => void;
  addRowItem: (item: LancamentoFinanceiro) => void;
  textColor: string;
  user: UsuarioModel;
  selectedCliente: PessoaType;
  tipo: boolean;
}

const AddLancamentoRow = ({
  showError,
  addRowItem,
  textColor,
  user,
  selectedCliente,
  tipo,
}: IAddLancamentoRow) => {
  const [data, setData] = useState<Date>(new Date());
  const [vencimento, setVencimento] = useState<Date>(new Date());
  const [valor, setValor] = useState(0);
  const [acrescimo, setAcrescimo] = useState(0);
  const [desconto, setDesconto] = useState(0);
  const [total, setTotal] = useState(0);
  const [obs, setObs] = useState("");
  const [tipoRecebimento, setTipoRecebimento] = useState("");

  const cleanInput = () => {
    setData(new Date());
    setVencimento(new Date());
    setValor(0);
    setAcrescimo(0);
    setDesconto(0);
    setTotal(0);
  };

  const onChangeData = (date: any) => {
    setData(date);
  };
  const onChangeVencimento = (date: any) => {
    setVencimento(date);
  };
  const onChangeValor = (valor: string) => {
    setValor(Number(valor));
  };

  const onChangeAcrescimo = (valor: string) => {
    setAcrescimo(Number(valor));
  };

  const onChangeDesconto = (valor: string) => {
    setDesconto(Number(valor));
  };

  const onChangeObs = (valor: string) => {
    setObs(valor);
  };

  const onChangeTipoRecebimento = (valor: string) => {
    setTipoRecebimento(valor);
  };

  const calculaTotal = () => {
    const calc = valor + acrescimo - desconto;

    setTotal(calc);
  };

  const add = () => {
    calculaTotal();

    if (!selectedCliente) {
      showError("Erro!", "Selecione o Cliente antes de inserir os Lançamentos");
      return;
    }

    if (valor <= 0) {
      showError("Erro!", "Preencha um valor maior do que zero");
      return;
    }

    const obj = {
      acrescimo: acrescimo,
      competencia: data,
      data: new Date(),
      desconto: desconto,
      idEmpresa: user.idEmpresa,
      idPessoa: selectedCliente.id,
      texto: "",
      vencimento: vencimento,
      tipo: tipo ? "0" : "1",
      valor: valor,
      id: "",
      contaPagarId: "",
      contaReceberId: "",
      pago: false,
      marcado: false,
      dataPago: new Date(),
      obs: obs,
      tipoRecebimento: tipoRecebimento,
    };
    addRowItem(obj);
    cleanInput();
  };

  return (
    <Tr>
      <Td>
        <FormControl w={36}>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={vencimento}
            onDateChange={(date: any) => {
              onChangeVencimento(date);
            }}
          />
        </FormControl>
      </Td>
      <Td>
        <FormControl>
          <NumberInput
            min={0}
            precision={2}
            w={28}
            onChange={(e: string) => {
              onChangeValor(e);
            }}
            onBlur={() => calculaTotal()}
            value={valor}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>
      </Td>
      <Td>
        <FormControl>
          <NumberInput
            min={0}
            precision={2}
            w={28}
            onChange={(e: string) => {
              onChangeAcrescimo(e);
            }}
            onBlur={() => calculaTotal()}
            value={acrescimo}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>
      </Td>
      <Td>
        <FormControl>
          <NumberInput
            min={0}
            precision={2}
            w={28}
            onChange={(e: string) => {
              onChangeDesconto(e);
            }}
            onBlur={() => calculaTotal()}
            value={desconto}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>
      </Td>
      <Td>{formatNumber(Number(total))}</Td>
      <Td>
        <FormControl>
          <Select
            size="md"
            w={48}
            onChange={(e) => onChangeTipoRecebimento(e.target.value)}
            value={tipoRecebimento}
          >
            <option value={"0"}>SELECIONE...</option>
            <option value={"1"}>BOLETO</option>
            <option value={"2"}>CHEQUE</option>
            <option value={"3"}>CARTÃO</option>
            <option value={"4"}>DINHEIRO</option>
            <option value={"5"}>DEPÓSITO</option>
            <option value={"6"}>DÉBITO EM CONTA</option>
            <option value={"7"}>FATURA</option>
            <option value={"8"}>ARRECADAÇÃO/RECEBIMENTO</option>
            <option value={"9"}>TRANSFÊRENCIA</option>
            <option value={"10"}>PIX</option>
          </Select>
        </FormControl>
      </Td>
      <Td>
        <FormControl>
          <Input
            defaultValue={obs}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Preencha a Descrição"
            onChange={(e) => onChangeObs(e.target.value)}
            fontWeight="500"
            size="lg"
          />
        </FormControl>
      </Td>
      <Td>
        <Button
          onClick={() => {
            add();
          }}
          colorScheme="green"
          variant="ghost"
        >
          INSERIR
        </Button>
      </Td>
    </Tr>
  );
};
export default AddLancamentoRow;
